import {
  CodeBlock as BaseCodeBlock,
  CodeBlockBody,
  CodeBlockItem,
  CodeBlockContent,
  CodeBlockCopyButton,
  BundledLanguage,
} from '@cotera/client/v0/components/ui/code-block';

export const CodeBlock: React.FC<{
  code: string;
  language: string;
  bordered?: boolean;
  wrap?: boolean;
  showCopyButton?: boolean;
}> = ({
  code,
  language,
  bordered = true,
  wrap = false,
  showCopyButton = false,
}) => {
  return (
    <BaseCodeBlock
      data={[{ language, code: code ?? 'NULL' }]}
      defaultValue={language}
      bordered={bordered}
    >
      <div className="relative [&_*]:!select-text">
        {showCopyButton && (
          <div className="absolute top-2 right-2 z-10">
            <CodeBlockCopyButton />
          </div>
        )}
        <CodeBlockBody
          className={
            wrap
              ? 'min-h-10 [&_code]:!block [&_code]:overflow-x-hidden [&_code]:px-4 [&_.line]:whitespace-pre-wrap'
              : 'min-h-10'
          }
        >
          {(item) => (
            <CodeBlockItem
              key={item.language}
              value={item.language}
              lineNumbers={!wrap}
            >
              <CodeBlockContent language={item.language as BundledLanguage}>
                {item.code}
              </CodeBlockContent>
            </CodeBlockItem>
          )}
        </CodeBlockBody>
      </div>
    </BaseCodeBlock>
  );
};
